import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead } from "@/lib/seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

export const Route = createFileRoute("/es/privacidad")({
  loader: async () => { await setEdgeHtmlCache({ sMaxAge: 1800 }); },
  head: () => buildHead({
    locale: "es",
    title: "Política de privacidad: Shugert",
    description: "Cómo Shugert Agency recopila, usa y protege tus datos personales en shugert.com.mx, conforme al RGPD, UK GDPR y la LFPDPPP de México.",
    path: "/es/privacidad",
    altPath: alternatePath("/es/privacidad", "en"),
  }),
});
